import { Table } from "@mantine/core";
import { HeldEmailListItem } from "../../../services/admin/systemEmails.service";
import { HeldEmailSelectionModel } from "./heldEmailSelection";
import { HeldEmailQueueRowContainer } from "./HeldEmailQueueRowContainer";

interface Props {
  emails: HeldEmailListItem[];
  canRelease: boolean;
  selection: HeldEmailSelectionModel;
  onView: (id: string) => void;
  onRelease: (ids: string[]) => void;
  onCancel: (ids: string[]) => void;
}

export function HeldEmailQueueTableBody({ model }: { model: Props }) {
  return (
    <Table.Tbody>
      {model.emails.map((email) => (
        <HeldEmailQueueRowContainer
          key={email.id}
          model={{
            canRelease: model.canRelease,
            email,
            onCancel: model.onCancel,
            onRelease: model.onRelease,
            onView: model.onView,
            selection: model.selection,
          }}
        />
      ))}
    </Table.Tbody>
  );
}
